var map = {
	"./01_welcome-to-stayokay.1024.png": 250,
	"./01_welcome-to-stayokay.1024.webp": 6828,
	"./01_welcome-to-stayokay.1280.png": 1662,
	"./01_welcome-to-stayokay.1280.webp": 7228,
	"./01_welcome-to-stayokay.1536.png": 9498,
	"./01_welcome-to-stayokay.1536.webp": 7672,
	"./01_welcome-to-stayokay.640.png": 1429,
	"./01_welcome-to-stayokay.640.webp": 8427,
	"./01_welcome-to-stayokay.768.png": 9694,
	"./01_welcome-to-stayokay.768.webp": 3950,
	"./01_welcome-to-stayokay.original.png": 4170,
	"./01_welcome-to-stayokay.original.webp": 3272,
	"./02_self-contained-rooms.1024.jpg": 6433,
	"./02_self-contained-rooms.1024.webp": 7610,
	"./02_self-contained-rooms.1280.jpg": 3562,
	"./02_self-contained-rooms.1280.webp": 2442,
	"./02_self-contained-rooms.1536.jpg": 9102,
	"./02_self-contained-rooms.1536.webp": 6866,
	"./02_self-contained-rooms.640.jpg": 4245,
	"./02_self-contained-rooms.640.webp": 6981,
	"./02_self-contained-rooms.768.jpg": 7021,
	"./02_self-contained-rooms.768.webp": 7740,
	"./02_self-contained-rooms.original.jpg": 606,
	"./02_self-contained-rooms.original.webp": 9146,
	"./03_fully-equipped-kitchen.1024.png": 1979,
	"./03_fully-equipped-kitchen.1024.webp": 5641,
	"./03_fully-equipped-kitchen.1280.png": 6179,
	"./03_fully-equipped-kitchen.1280.webp": 2941,
	"./03_fully-equipped-kitchen.1536.png": 3511,
	"./03_fully-equipped-kitchen.1536.webp": 4357,
	"./03_fully-equipped-kitchen.640.png": 1856,
	"./03_fully-equipped-kitchen.640.webp": 4008,
	"./03_fully-equipped-kitchen.768.png": 7913,
	"./03_fully-equipped-kitchen.768.webp": 4365,
	"./03_fully-equipped-kitchen.original.png": 6279,
	"./03_fully-equipped-kitchen.original.webp": 3381,
	"./04_spacious-parking-area.1024.png": 3021,
	"./04_spacious-parking-area.1024.webp": 5157,
	"./04_spacious-parking-area.1280.png": 6917,
	"./04_spacious-parking-area.1280.webp": 3505,
	"./04_spacious-parking-area.1536.png": 1677,
	"./04_spacious-parking-area.1536.webp": 7753,
	"./04_spacious-parking-area.640.png": 180,
	"./04_spacious-parking-area.640.webp": 2788,
	"./04_spacious-parking-area.768.png": 5627,
	"./04_spacious-parking-area.768.webp": 1193,
	"./04_spacious-parking-area.original.png": 6677,
	"./04_spacious-parking-area.original.webp": 2905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;